import { getToken, removeToken } from './loginTokens';
import { formatMegabytes } from './numberUtils';

// Limite de 10mb do nginx (client_max_body_size). Payloads a partir disso
// nem chegam a ser enviados, para o usuario receber o erro na hora.
const PAYLOAD_SIZE_LIMIT = 10 * 1024 * 1024;
// Boundary, cabecalhos e quebras de linha de cada campo do multipart.
const MULTIPART_PART_OVERHEAD = 128;

const hasFiles = (formData) => {
    for (const [, value] of formData.entries()) {
        if (value instanceof Blob) {
            return true;
        }
    }
    return false;
};

const getPayloadSize = (formData) => {
    let size = 0;
    for (const [key, value] of formData.entries()) {
        size += MULTIPART_PART_OVERHEAD + new Blob([key]).size;
        if (value instanceof Blob) {
            size += value.size + new Blob([value.name || '']).size;
        } else {
            size += new Blob([value]).size;
        }
    }
    return size;
};

export async function fetchFlask (api, body = null, blob = false) {
    const loginToken = getToken();

    const trimStrings = (obj) => {
        if (obj instanceof FormData) {
            const newBody = new FormData();
            for (const pair of obj.entries()) {
                let [key, value] = pair;
                if (typeof value === 'string') {
                    value = value.trim();
                }
                newBody.append(key, value);
            }
            body = newBody;
        } else if (Array.isArray(obj)) {
                for (let i = 0; i < obj.length; i++) {
                    if (typeof obj[i] === 'string') {
                        obj[i] = obj[i].trim();
                    } else if (typeof obj[i] === 'object') {
                        trimStrings(obj[i]);
                    }
                }
        } else {
            if (typeof obj === 'string') {
                obj = JSON.parse(obj);
            };
            for (const key in obj) {
                if (typeof obj[key] === 'string') {
                    obj[key] = obj[key].trim();
                } else if (typeof obj[key] === 'object') {
                    trimStrings(obj[key]);
                }
            }
            body = JSON.stringify(obj);
        }
    };

    const options = {
        headers: {
            Authorization: 'Bearer ' + loginToken
        }
    };
    if (body) {
        options.method = 'POST';
        trimStrings(body);
        options.body = body;
        if (!(body instanceof FormData)) {
            options.headers['Content-Type'] = 'application/json';
        } else if (hasFiles(body)) {
            const payloadSize = getPayloadSize(body);
            if (payloadSize >= PAYLOAD_SIZE_LIMIT) {
                return {
                    message: `Error: Os arquivos selecionados somam ${formatMegabytes(payloadSize)}MB e ultrapassam o limite de ${formatMegabytes(PAYLOAD_SIZE_LIMIT)}MB por envio! Reduza ou divida os arquivos e tente novamente.`,
                    status: 'error'
                };
            }
        }
    }

    try {
        const response = await fetch('https://api.settacorporativo.com/' + api, options);

        if (blob) {
            return await response.blob();
        }

        if (response.headers.get('Content-Type').includes('text/csv;') ||
            response.headers.get('Content-Type').includes('application/pdf') ||
            response.headers.get('Content-Type').includes('spreadsheetml.sheet')) {
            return await response.blob();
        }

        const responseJson = await response.json();
        if ('msg' in responseJson) {
            alert('Sua sessão expirou! Por favor faça login novamente!');
            removeToken();
        } else {
            return responseJson;
        }
    } catch (error) {
        return { message: 'Error: Falha no Servidor!', status: 'error' };
    }
}
